import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ReactComponent as TickCircleGreen } from '../../../assets/icons/tick-circle-green.svg';
import AppContext from '../../context';

const MFSyncStatus = (props) => {
  const context = useContext(AppContext);
  const [show, setShow] = useState(false);

  const { pf } = props;

  const areAllPfsEmpty = () => {
    return !context.portfolios.some(
      (pf) => !pf.is_empty && pf.is_empty !== undefined,
    );
  };

  useEffect(() => {
    if (pf && !areAllPfsEmpty()) setShow(true);
  }, [pf]);

  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      animation={false}
      className="import_mfs__modal"
      onHide={() => setShow(false)}
    >
      <Modal.Body>
        <div className="content_header">
          <h4>
            {pf
              ? areAllPfsEmpty()
                ? 'Portfolio'
                : pf.name
              : 'Fetch your Mutual Funds'}
          </h4>
        </div>
        <div className="content_body">
          <div className="fetching_funds">
            <TickCircleGreen />
            <p>Your Mutual Funds are successfully fetched</p>
            <button
              type="button"
              className="close_and_reload"
              onClick={() => window.location.reload()}
            >
              Close and Reload Portfolio
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MFSyncStatus;
